import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-login-layout',
  templateUrl: './admin-login-layout.component.html',
  styleUrls: ['./admin-login-layout.component.scss']
})
export class AdminLoginLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
